// source chooser directive
//
//   <source-chooser edit-or-create-event-service="vm.service" />
//

let module = angular.module('app.directives');

module.directive('sourceChooser', () => {
  return {
    restrict: 'E',
    scope: {
      editOrCreateEventService: '=',
    },
    template: `
      <div ng-if="(editOrCreateEventService.broadcast.timeframe||'future') != 'future'">
        {{editOrCreateEventService.broadcast | streamSourceName}}
      </div>
      <div ng-if="(editOrCreateEventService.broadcast.timeframe||'future') == 'future'">
        <select selectize
              ng-model="editOrCreateEventService.broadcast.boxcaster_id"
              ng-change="editOrCreateEventService.updateScoreboardMakes(); editOrCreateEventService.getConflictingEvents()"
              options="editOrCreateEventService.sources"
              config="selectizeConfig"></select>
        <div style="margin:5px 0 0 0" ng-if="firmwareIssue || firmwareUpdate">
          <a ng-if="firmwareIssue" href="{{vueDashboardRoot}}/sources?boxcaster_id={{editOrCreateEventService.broadcast.boxcaster_id}}" class="label label-warning">
            Firmware Issue
          </a>
          <a ng-if="firmwareUpdate" href="{{vueDashboardRoot}}/sources?boxcaster_id={{editOrCreateEventService.broadcast.boxcaster_id}}" class="label label-info">
            Firmware Update Available
          </a>
        </div>
      </div>
    `,
    controller: function ($scope) {
      'ngInject';

      $scope.$watch(
        () => $scope.editOrCreateEventService.selectedBoxCaster,
        (boxcaster) => {
          $scope.shouldBeBroadcasting = shouldBeBroadcasting(boxcaster);
          $scope.firmwareIssue = boxcaster && boxcaster.firmware_status == 'invalid';
          $scope.firmwareUpdate = boxcaster && boxcaster.firmware_status == 'outdated';
        }
      );

      $scope.selectizeConfig = {
        valueField: 'id',
        labelField: 'name',
        placeholder: 'Select Source...',
        highlight: true,
        searchField: 'name',
        selectOnTab: true,
        closeAfterSelect: true,
        maxItems: 1,
        render: {
          option: renderSelectizeOption('source-chooser--option'),
          item: renderSelectizeOption('source-chooser--selected'),
        },
      };
    },
  };
});

function shouldBeBroadcasting(boxcaster) {
  if (boxcaster && boxcaster.next_broadcast_at) {
    return Date.now() > moment(boxcaster.next_broadcast_at);
  } else {
    return false;
  }
}

function renderSelectizeOption(wrapperCssClass) {
  return function (item, escape) {
    if (item.type.startsWith('boxcaster')) {
      return `
        <div class="${wrapperCssClass}">
          <small class="pull-right" style="text-transform:capitalize">
            ${boxcasterStatusIcon(item)}
          </small>
          <span class="source-icon source-icon--${item.type}"/>
          ${item.name}
        </div>
      `;
    } else if (item.type === 'static_rtmp') {
      return `
        <div class="${wrapperCssClass}">
          <small class="pull-right" style="text-transform:capitalize">
            ${staticRtmpStatusIcon(item)}
          </small>
          <span class="source-icon source-icon--${item.type}"/>
          ${item.name}
        </div>
      `;
    } else if (item.type === 'recording') {
      return `
        <div class="${wrapperCssClass}">
          <i class="fa fa-repeat" style="width:15px; margin-left: 5px; margin-right: 10px;"></i>
          ${item.name}
        </div>
      `;
    } else {
      return `
        <div class="${wrapperCssClass}">
          <span class="source-icon source-icon--${item.type}"/>
          ${item.name}
        </div>
      `;
    }
  };
}

function boxcasterStatusIcon(item) {
  // Simplified version of <boxcaster-status-label /> logic
  if (item.status == 'ready') {
    return `<i class="source-icon--ready fa fa-circle"></i> Online`;
  } else if (item.status.indexOf('broadcast') >= 0) {
    return `<i class="source-icon--in-use fa fa-circle"></i> Broadcasting`;
  } else if (shouldBeBroadcasting(item)) {
    return `<i class="source-icon--issue fa fa-circle"></i> Check Source`;
  } else {
    return `<i class="source-icon--offline fa fa-circle"></i> ${item.status}`;
  }
}

function staticRtmpStatusIcon(item) {
  if (!(item.diagnostics || {}).connected) {
    return `<i class="source-icon--offline fa fa-circle"></i> Offline`;
  }
  if (item.diagnostics.broadcasting) {
    return `<i class="source-icon--in-use fa fa-circle"></i> Broadcasting`;
  }
  return `<i class="source-icon--ready fa fa-circle"></i> Connected`;
}



// WEBPACK FOOTER //
// ./app/directives/source-chooser.js